export default __webpack_public_path__ + "static/media/slider-fast.65ff1bfe.png";